<template>
  <div>
  </div>
</template>

<script>
// 单独引用axios
import axios from "axios";

export default {
  data() {
    return {
      // 跳转携带的入口参数
      from:"",
    }
  },
  mounted: async function () {
    if (this.$route.query.from) {
      this.from = this.$route.query.from;
    }
    // 先判断有没有上次残留的sessionId
    if (window.localStorage.getItem("sessionId") != null) {
      console.log("有发现有sessionId啊"+window.localStorage.getItem("sessionId"))
      await this.$router.replace({
        name: "DiscountHomePage",
      });
    }
    else {
      // 查看是否有authCode和clientId
      let authCode = this.GetQueryString("authCode");
      let clientId = this.GetQueryString("clientId");
      if (authCode && clientId) {
        // 已授权
        var url =
            window.location.host.match(/test/) == null
                ? "/static/api/oauth/accessToken"
                : "/static/api/oauth/accessToken2";
        // 获取sessionId
        let params = {
          authCode: authCode,
          clientId: clientId,
          grantType: "authorization_code",
        };
        var queryString = [];
        for (var key in params) {
          queryString.push("".concat(key, "=").concat(params[key]));
        }

        if (queryString.length > 0) {
          queryString = queryString.join("&");
          url += "?".concat(queryString);
        }
        await axios.get(url).then((res) => {
          if (res.data.bizCode == "SUCCESS" && res.data.code == "SUCCESS") {
            // 拿到了sessionId
            var result = JSON.parse(res.data.bizResp);
            window.localStorage.setItem("sessionId", result.sessionId);
            if (this.from){
              this.$router.replace({
                name: "DiscountHomePage",
                query: {
                  from: this.from,
                },
              });
            }else{
              this.$router.replace({
                name: "DiscountHomePage",
              });
            }
          } else {
            // 换取sessionId失败 重新授权
            setTimeout(() => {
              this.loadOauthUrl();
            }, 0);
          }
        });
      } else {
        // 未授权
        setTimeout(() => {
          this.loadOauthUrl();
        }, 0);
      }
    }
  },
  methods: {
    GetQueryString: function (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // oauth授权
    loadOauthUrl: function () {
      // 收集需要传递的参数，只保留非空值
      const params = {};
      if (this.from) {
        params.from = this.from;
      }
      // 使用 URLSearchParams 构建查询字符串
      const queryString = new URLSearchParams(params).toString();
      // 拼接最终跳转 URL
      const redirectUrl = process.env.VUE_APP_URL + `#/OauthPage?${queryString}`;
      // 编码并跳转
      window.location.href =
          process.env.VUE_APP_OAUTH_URL +
          encodeURIComponent(redirectUrl) +
          "&state=123";
    },

  },
};
</script>

<style>
</style>
